if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.mediaItems = [];
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.controlsCreated = false;
      }

      show(opener) {
        super.show(opener);
        this.setupCarousel();
        this.showActiveMedia();
      }

      hide() {
        super.hide();
      }

      setupCarousel() {
        const container = this.querySelector('.product-media-modal__content');

        if (!container) return;

        this.mediaItems = Array.from(
          container.querySelectorAll('[data-media-id]')
        );

        if (!this.controlsCreated && this.mediaItems.length > 1) {
          this.createNavigation(container);
          this.addKeyboardNavigation();
          this.addTouchNavigation(container);
          this.controlsCreated = true;
        }
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');

        this.mediaItems = Array.from(
          this.querySelectorAll('.product-media-modal__content [data-media-id]')
        );

        const activeIndex = this.mediaItems.findIndex(
          (element) => element.getAttribute('data-media-id') === mediaId
        );

        this.currentIndex = activeIndex >= 0 ? activeIndex : 0;

        this.updateActiveMedia();
      }

      updateActiveMedia() {
        if (!this.mediaItems.length) return;

        this.mediaItems.forEach((element, index) => {
          element.classList.toggle('active', index === this.currentIndex);
        });

        const activeMedia = this.mediaItems[this.currentIndex];

        const container = this.querySelector(
          '.product-media-modal__content'
        );

        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        if (
          activeMedia &&
          activeMedia.nodeName === 'DEFERRED-MEDIA'
        ) {
          const activeMediaTemplate = activeMedia.querySelector('template');

          if (
            activeMediaTemplate &&
            activeMediaTemplate.content.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }

        this.updateNavigation();
      }

      goToPrevious() {
        if (this.mediaItems.length < 2) return;

        this.currentIndex =
          (this.currentIndex - 1 + this.mediaItems.length) %
          this.mediaItems.length;

        this.updateActiveMedia();
      }

      goToNext() {
        if (this.mediaItems.length < 2) return;

        this.currentIndex =
          (this.currentIndex + 1) % this.mediaItems.length;

        this.updateActiveMedia();
      }

      createNavigation(container) {
        const dialog = this.querySelector(
          '.product-media-modal__dialog'
        );

        if (!dialog) return;

        this.previousButton = document.createElement('button');
        this.previousButton.type = 'button';
        this.previousButton.className =
          'product-media-modal__nav product-media-modal__nav--previous';
        this.previousButton.setAttribute(
          'aria-label',
          'Previous image'
        );
        this.previousButton.innerHTML = '&#10094;';

        this.nextButton = document.createElement('button');
        this.nextButton.type = 'button';
        this.nextButton.className =
          'product-media-modal__nav product-media-modal__nav--next';
        this.nextButton.setAttribute(
          'aria-label',
          'Next image'
        );
        this.nextButton.innerHTML = '&#10095;';

        this.previousButton.addEventListener('click', () => {
          this.goToPrevious();
        });

        this.nextButton.addEventListener('click', () => {
          this.goToNext();
        });

        dialog.appendChild(this.previousButton);
        dialog.appendChild(this.nextButton);
      }

      updateNavigation() {
        if (!this.previousButton || !this.nextButton) return;

        const hasMultipleImages = this.mediaItems.length > 1;

        this.previousButton.hidden = !hasMultipleImages;
        this.nextButton.hidden = !hasMultipleImages;
      }

      addKeyboardNavigation() {
        this.addEventListener('keydown', (event) => {
          if (!this.openedBy) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goToPrevious();
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goToNext();
          }
        });
      }

      addTouchNavigation(container) {
        container.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.changedTouches[0].screenX;
          },
          { passive: true }
        );

        container.addEventListener(
          'touchend',
          (event) => {
            this.touchEndX = event.changedTouches[0].screenX;

            const swipeDistance =
              this.touchStartX - this.touchEndX;

            if (Math.abs(swipeDistance) < 50) return;

            if (swipeDistance > 0) {
              this.goToNext();
            } else {
              this.goToPrevious();
            }
          },
          { passive: true }
        );
      }
    }
  );
}